import { axiosInstance } from '@/api/axiosInstance';

const consentBase = '/oauth/v1/consent/';
const authorisationBase = '/oauth/v1/authorisation/';

export type ConsentScope = {
  name: string;
  description: string;
};

export type ConsentRequest = {
  client_name: string;
  redirect_host: string;
  scopes: ConsentScope[];
  user_email: string;
};

export type ConsentDecision = {
  redirect_to: string;
};

export type Authorisation = {
  client_id: string;
  client_name: string;
  redirect_hosts: string[];
  scopes: string[];
  authorised_at: string;
  last_refreshed: string | null;
};

export const getConsent = async (id: string) => {
  const response = await axiosInstance.get<ConsentRequest>(
    `${consentBase}${encodeURIComponent(id)}/`,
  );
  return response.data;
};

export const decideConsent = async (id: string, allow: boolean) => {
  const response = await axiosInstance.post<ConsentDecision>(
    `${consentBase}${encodeURIComponent(id)}/`,
    { allow },
  );
  return response.data;
};

export const listAuthorisations = async ({
  signal,
}: { signal?: AbortSignal } = {}) => {
  const response = await axiosInstance.get<
    Authorisation[] | { results: Authorisation[] }
  >(authorisationBase, { signal });
  return Array.isArray(response.data) ? response.data : response.data.results;
};

export const revokeAuthorisation = async (clientId: string) => {
  await axiosInstance.delete(
    `${authorisationBase}${encodeURIComponent(clientId)}/`,
  );
};
